module.exports = __webpack_public_path__ + "assets/ATrByOrthocenter.7261b4df8e11c0ded649671b5c281c05.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ATrByOrthocenter.gmt
// module id = 890
// module chunks = 0